import API from '@Services/apiAxios';
import axios from 'axios';

export interface PresignedUrlResponse {
  url: string;
  fields: Record<string, string>;
  key: string;
}

export const getExtractUploadUrl = async (
  filename: string,
  mimeType: string,
  orgCode: string,
  sessionId?: string,
): Promise<PresignedUrlResponse> => {
  const requestHeaders: Record<string, string> = {
    org_code: orgCode,
  };
  if (sessionId) {
    requestHeaders['sessionId'] = sessionId;
  }

  const response = await API.post<PresignedUrlResponse>(
    '/speedboxbot/extract/upload-url',
    {
      fileName: filename,
      mimeType,
    },
    {
      headers: requestHeaders,
    },
  );
  return response.data;
};

export const uploadToPresignedS3 = async (
  url: string,
  fields: Record<string, string>,
  file: File,
  onUploadProgress?: (percent: number) => void,
): Promise<void> => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  // Use a clean axios instance for the S3 POST request to avoid custom API headers
  await axios.post(url, formData, {
    onUploadProgress: progressEvent => {
      if (onUploadProgress) {
        const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
        onUploadProgress(percent);
      }
    },
  });
};
